import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Wallet, UserPlus, Copy, MessageCircle } from "lucide-react";

const Box = ({ label, value, tone, testid }) => (
  <div className="rounded-lg border border-border/60 bg-card/60 p-3 text-center">
    <p className="eyebrow text-muted-foreground">{label}</p>
    <p className={`font-serif text-2xl mt-1 ${tone}`} data-testid={testid}>{inr(value)}</p>
  </div>
);

export const MyCommission = () => {
  const [d, setD] = useState({ earned: 0, paid: 0, due: 0, recent: [] });
  const [code, setCode] = useState("");
  useEffect(() => {
    api.get("/commission/my").then((r) => setD(r.data)).catch(() => {});
    api.get("/my-referral").then((r) => setCode(r.data.referral_code || "")).catch(() => {});
  }, []);
  const link = `${window.location.origin}/agent${code ? `?ref=${code}` : ""}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(`Join my team at Bengal Umrah House Travels and earn commission on every Umrah pilgrim: ${link}`)}`;
  return (
    <Card className="bg-card/40 border-gold/30 p-5 mb-6" data-testid="my-commission">
      <p className="eyebrow text-gold flex items-center gap-1.5 mb-4"><Wallet className="w-4 h-4" /> My commission</p>
      <div className="grid grid-cols-3 gap-3">
        <Box label="Earned" value={d.earned} tone="text-white" testid="my-comm-earned" />
        <Box label="Got (paid)" value={d.paid} tone="text-emerald-300" testid="my-comm-paid" />
        <Box label="Due" value={d.due} tone="text-gold" testid="my-comm-due" />
      </div>
      <div className="mt-4 rounded-lg border border-gold/40 bg-gold/10 p-3 flex flex-wrap items-center gap-3">
        <UserPlus className="w-5 h-5 text-gold" />
        <span className="flex-1 min-w-[200px] text-sm text-white">Join members under you — every sale in your team earns you commission.</span>
        <Button size="sm" onClick={() => { navigator.clipboard.writeText(link); toast.success("Joining link copied"); }} data-testid="my-join-team-copy"
          className="h-8 bg-gold text-[#0a2e22] hover:bg-gold/90 gap-1.5 text-xs"><Copy className="w-3.5 h-3.5" /> Copy join link</Button>
        <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="my-join-team-wa">
          <Button size="sm" variant="outline" className="h-8 border-emerald-400/40 text-emerald-300 gap-1.5 text-xs"><MessageCircle className="w-3.5 h-3.5" /> Join my team</Button>
        </a>
      </div>
      {d.recent.length > 0 && (
        <div className="mt-4 space-y-1.5">
          {d.recent.map((r) => (
            <div key={r.id} className="flex items-center justify-between text-xs border-b border-border/40 pb-1.5" data-testid={`my-comm-row-${r.id}`}>
              <span className="text-muted-foreground capitalize">{r.sale_type} sale · {new Date(r.created_at).toLocaleDateString("en-IN")}</span>
              <span className={r.status === "paid" ? "text-emerald-300" : "text-gold"}>{inr(r.amount)} · {r.status === "paid" ? "Paid" : "Due"}</span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
